import * as React from 'react';
import {classes, stylesheet} from 'typestyle';
import {I18n} from '../../i18n/i18n';
import {PageLayout} from '../types/Report';
import {LightGreyColor, BlueColor, WhiteColor} from '../../styles/colors';

interface PageLayoutChangerProps {
    setPageLayout: (pageLayout: PageLayout) => void;
    pageLayout: PageLayout;
}

export function PageLayoutChanger({setPageLayout, pageLayout}: PageLayoutChangerProps) {
    return (
        <div>
            <div className={layoutCss.reportTitle}>
                <I18n i18nKey="report:pageLayout" />
            </div>
            <div className={layoutCss.layoutContainer}>
                <div
                    onClick={() => setPageLayout(PageLayout.LANDSCAPE)}
                    className={classes(layoutCss.layoutOption, pageLayout === PageLayout.LANDSCAPE ? 'active' : undefined)}>
                    <I18n i18nKey="report:landscapeMode" />
                </div>
                <div
                    onClick={() => setPageLayout(PageLayout.PORTRAIT)}
                    className={classes(layoutCss.layoutOption, pageLayout === PageLayout.PORTRAIT ? 'active' : undefined)}>
                    <I18n i18nKey="report:portraitMode" />
                </div>
            </div>
        </div>
    );
}

const layoutCss = stylesheet({
    reportTitle: {
        fontSize: 12,
        marginLeft: 15,
        fontWeight: 'bold',
        marginBottom: 5,
    },
    layoutOption: {
        cursor: 'pointer',
        flex: 1,
        textAlign: 'center',
        border: '1px solid ' + LightGreyColor,
        borderRadius: 2,
        padding: 15,
        $nest: {
            '&:last-child': {
                borderLeft: 'none',
            },
            '&.active': {
                backgroundColor: BlueColor,
                color: WhiteColor,
            },
        },
    },
    layoutContainer: {
        display: 'flex',
        padding: '0px 15px 15px 15px',
    },
});



// WEBPACK FOOTER //
// ./src/report/views/PageLayoutChanger.tsx